module.exports = __webpack_public_path__ + "static/media/displaygroup-1.5199b578.jpg";